import axiosInstance from '../utils/AxiosConfig';

class DashboardConfigService {
  // Obtener la configuración del dashboard del usuario actual
  async getDashboardConfig() {
    try {
      const response = await axiosInstance.get('/dashboard/config');
      return response.data.data || { charts: [] };
    } catch (error) {
      console.error('Error fetching dashboard config:', error);
      // Si no existe configuración, retornar array vacío
      if (error.response?.status === 404) {
        return { charts: [] };
      }
      throw error;
    }
  }

  // Guardar la configuración del dashboard del usuario actual
  async saveDashboardConfig(charts) {
    try {
      const response = await axiosInstance.post('/dashboard/config', {
        charts: charts.map(chart => ({
          id: chart.id,
          name: chart.name,
          component: chart.component,
          defaultSize: chart.defaultSize,
          category: chart.category
        }))
      });
      return response.data.data;
    } catch (error) {
      console.error('Error saving dashboard config:', error);
      throw error;
    }
  }

  // Eliminar la configuración del dashboard (restaurar a default)
  async deleteDashboardConfig() {
    try {
      const response = await axiosInstance.delete('/dashboard/config');
      return response.data.data;
    } catch (error) {
      console.error('Error deleting dashboard config:', error);
      throw error;
    }
  }
}

export default new DashboardConfigService();

